"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClientManager = void 0;
const auth0_spa_js_1 = require("@auth0/auth0-spa-js");
const AuthClientOptionsFactory_1 = require("../Session/AuthClientOptionsFactory");
class AuthClientManager {
    authClient = null;
    async initializeDefaultAuthClient() {
        if (!this.authClient) {
            const authClientOptionsFactory = new AuthClientOptionsFactory_1.AuthClientOptionsFactory();
            const authClientOptions = authClientOptionsFactory.getAuthClientOptions();
            this.authClient = await (0, auth0_spa_js_1.createAuth0Client)(authClientOptions);
        }
        return this.authClient;
    }
    async getAuthClient(customAuthClient) {
        if (customAuthClient) {
            return customAuthClient;
        }
        return this.initializeDefaultAuthClient();
    }
}
exports.AuthClientManager = AuthClientManager;
//# sourceMappingURL=AuthClientManager.js.map